var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    { staticClass: "root" },
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            [
              _c(
                "w-row",
                { attrs: { "no-margin": "" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "breadcrumb",
                      style: { flexShrink: 0, flexGrow: 0 },
                    },
                    [
                      _vm._v(
                        " Te verwijderen databases van " +
                          _vm._s(_vm.serverName) +
                          " "
                      ),
                    ]
                  ),
                  _c("w-spacer"),
                  _c(
                    "w-button-bar",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Refresh",
                              expression: "'Refresh'",
                            },
                          ],
                          attrs: { disabled: _vm.isFetching },
                          on: {
                            click: function ($event) {
                              return _vm.fetch()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "sync" } })],
                        1
                      ),
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Account bekijken",
                              expression: "'Account bekijken'",
                            },
                          ],
                          attrs: { disabled: _vm.infoDisabled },
                          on: {
                            click: function ($event) {
                              return _vm.openInfo()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "eye" } })],
                        1
                      ),
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Database verwijderen",
                              expression: "'Database verwijderen'",
                            },
                          ],
                          attrs: { disabled: _vm.deleteDisabled },
                          on: {
                            click: function ($event) {
                              return _vm.deleteDb()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "trash" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        { style: { flexGrow: 1, flexShrink: 1 } },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-card",
                { style: { flexGrow: 1, flexShrink: 1, maxHeight: "100%" } },
                [
                  _c("w-data-table", {
                    attrs: {
                      items: _vm.dbs,
                      columns: _vm.tableColumns,
                      "column-resize-handle": "",
                      "selected-items": _vm.selectedItems,
                      compare: _vm.getCompareFunc(),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }